// tslint:disable
/**
 * RenaissanceServices API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddAlertCommand
 */
export interface AddAlertCommand {
    /**
     * 
     * @type {string}
     * @memberof AddAlertCommand
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddAlertCommand
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AddAlertCommand
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AddAlertCommand
     */
    endDate?: Date;
}
/**
 * 
 * @export
 * @interface ApplicationStatusDto
 */
export interface ApplicationStatusDto {
    /**
     * 
     * @type {string}
     * @memberof ApplicationStatusDto
     */
    sceneID?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationStatusDto
     */
    status?: number | null;
}
/**
 * 
 * @export
 * @interface ArgumentException
 */
export interface ArgumentException {
    /**
     * 
     * @type {string}
     * @memberof ArgumentException
     */
    message?: string | null;
    /**
     * 
     * @type {Exception}
     * @memberof ArgumentException
     */
    innerException?: Exception | null;
    /**
     * 
     * @type {string}
     * @memberof ArgumentException
     */
    stackTrace?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArgumentException
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArgumentException
     */
    paramName?: string | null;
}
/**
 * 
 * @export
 * @interface ArgumentExceptionAllOf
 */
export interface ArgumentExceptionAllOf {
    /**
     * 
     * @type {string}
     * @memberof ArgumentExceptionAllOf
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArgumentExceptionAllOf
     */
    paramName?: string | null;
}
/**
 * 
 * @export
 * @interface ArgumentNullException
 */
export interface ArgumentNullException extends ArgumentException {
}
/**
 * 
 * @export
 * @interface BOSToolsException
 */
export interface BOSToolsException extends Exception {
}
/**
 * 
 * @export
 * @interface CaseAgentNumber
 */
export interface CaseAgentNumber {
    /**
     * 
     * @type {string}
     * @memberof CaseAgentNumber
     */
    caseID?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseAgentNumber
     */
    caseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseAgentNumber
     */
    servicingAgentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseAgentNumber
     */
    agentOfRecordNumber?: string | null;
}
/**
 * 
 * @export
 * @interface CaseAgentNumberDto
 */
export interface CaseAgentNumberDto {
    /**
     * 
     * @type {string}
     * @memberof CaseAgentNumberDto
     */
    caseID?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseAgentNumberDto
     */
    caseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseAgentNumberDto
     */
    servicingAgentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseAgentNumberDto
     */
    agentOfRecordNumber?: string | null;
}
/**
 * 
 * @export
 * @interface CaseNameDto
 */
export interface CaseNameDto {
    /**
     * 
     * @type {string}
     * @memberof CaseNameDto
     */
    groupID?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseNameDto
     */
    caseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseNameDto
     */
    caseName?: string | null;
}
/**
 * 
 * @export
 * @interface Exception
 */
export interface Exception {
    /**
     * 
     * @type {string}
     * @memberof Exception
     */
    message?: string | null;
    /**
     * 
     * @type {Exception}
     * @memberof Exception
     */
    innerException?: Exception | null;
    /**
     * 
     * @type {string}
     * @memberof Exception
     */
    stackTrace?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Exception
     */
    source?: string | null;
}
/**
 * 
 * @export
 * @interface GrandfatheringDataDto
 */
export interface GrandfatheringDataDto {
    /**
     * 
     * @type {string}
     * @memberof GrandfatheringDataDto
     */
    employeeIdentificationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GrandfatheringDataDto
     */
    caseNumbers?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GrandfatheringDataDto
     */
    channel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GrandfatheringDataDto
     */
    productAndPlans?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GrandfatheringDataDto
     */
    productTypes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GrandfatheringDataDto
     */
    isMissing?: string | null;
}
/**
 * 
 * @export
 * @interface LifeDetailDto
 */
export interface LifeDetailDto {
    /**
     * 
     * @type {number}
     * @memberof LifeDetailDto
     */
    employerID?: number;
    /**
     * 
     * @type {string}
     * @memberof LifeDetailDto
     */
    employerName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LifeDetailDto
     */
    accountNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LifeDetailDto
     */
    accountName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LifeDetailDto
     */
    writtenToL70?: boolean | null;
}
/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    href?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    rel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    verb?: string | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfGrandfatheringDataDto
 */
export interface PagedResultOfGrandfatheringDataDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfGrandfatheringDataDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfGrandfatheringDataDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<GrandfatheringDataDto>}
     * @memberof PagedResultOfGrandfatheringDataDto
     */
    result?: Array<GrandfatheringDataDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfGrandfatheringDataDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface SicCodeDto
 */
export interface SicCodeDto {
    /**
     * 
     * @type {string}
     * @memberof SicCodeDto
     */
    groupID?: string;
    /**
     * 
     * @type {string}
     * @memberof SicCodeDto
     */
    sicCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SicCodeDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SicCodeDto
     */
    caseNumber?: string | null;
}
/**
 * 
 * @export
 * @interface SystemException
 */
export interface SystemException extends Exception {
}
/**
 * 
 * @export
 * @interface UpdateAlertCommand
 */
export interface UpdateAlertCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateAlertCommand
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAlertCommand
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAlertCommand
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateAlertCommand
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateAlertCommand
     */
    endDate?: Date;
}

/**
 * AddressVerificationApi - axios parameter creator
 * @export
 */
export const AddressVerificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [number] 
         * @param {string} [street] 
         * @param {string} [city] 
         * @param {string} [state] 
         * @param {string} [zip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressVerificationIsAddressValid(version: string, number?: string, street?: string, city?: string, state?: string, zip?: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling addressVerificationIsAddressValid.');
            }
            const localVarPath = `/api/v{version}/address/IsAddressValid`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (number !== undefined) {
                localVarQueryParameter['Number'] = number;
            }

            if (street !== undefined) {
                localVarQueryParameter['Street'] = street;
            }

            if (city !== undefined) {
                localVarQueryParameter['City'] = city;
            }

            if (state !== undefined) {
                localVarQueryParameter['State'] = state;
            }

            if (zip !== undefined) {
                localVarQueryParameter['Zip'] = zip;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressVerificationApi - functional programming interface
 * @export
 */
export const AddressVerificationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [number] 
         * @param {string} [street] 
         * @param {string} [city] 
         * @param {string} [state] 
         * @param {string} [zip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressVerificationIsAddressValid(version: string, number?: string, street?: string, city?: string, state?: string, zip?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean> {
            const localVarAxiosArgs = AddressVerificationApiAxiosParamCreator(configuration).addressVerificationIsAddressValid(version, number, street, city, state, zip, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AddressVerificationApi - factory interface
 * @export
 */
export const AddressVerificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [number] 
         * @param {string} [street] 
         * @param {string} [city] 
         * @param {string} [state] 
         * @param {string} [zip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressVerificationIsAddressValid(version: string, number?: string, street?: string, city?: string, state?: string, zip?: string, options?: any): AxiosPromise<boolean> {
            return AddressVerificationApiFp(configuration).addressVerificationIsAddressValid(version, number, street, city, state, zip, options)(axios, basePath);
        },
    };
};

/**
 * AddressVerificationApi - object-oriented interface
 * @export
 * @class AddressVerificationApi
 * @extends {BaseAPI}
 */
export class AddressVerificationApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {string} [number] 
     * @param {string} [street] 
     * @param {string} [city] 
     * @param {string} [state] 
     * @param {string} [zip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressVerificationApi
     */
    public addressVerificationIsAddressValid(version: string, number?: string, street?: string, city?: string, state?: string, zip?: string, options?: any) {
        return AddressVerificationApiFp(this.configuration).addressVerificationIsAddressValid(version, number, street, city, state, zip, options)(this.axios, this.basePath);
    }

}


/**
 * AlertsApi - axios parameter creator
 * @export
 */
export const AlertsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddAlertCommand} addAlertCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsAddAlert(version: string, addAlertCommand: AddAlertCommand, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling alertsAddAlert.');
            }
            // verify required parameter 'addAlertCommand' is not null or undefined
            if (addAlertCommand === null || addAlertCommand === undefined) {
                throw new RequiredError('addAlertCommand','Required parameter addAlertCommand was null or undefined when calling alertsAddAlert.');
            }
            const localVarPath = `/api/v{version}/alerts`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof addAlertCommand !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addAlertCommand !== undefined ? addAlertCommand : {}) : (addAlertCommand || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsDeleteAlert(id: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling alertsDeleteAlert.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling alertsDeleteAlert.');
            }
            const localVarPath = `/api/v{version}/alerts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsGetAlert(id: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling alertsGetAlert.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling alertsGetAlert.');
            }
            const localVarPath = `/api/v{version}/alerts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsGetAlerts(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling alertsGetAlerts.');
            }
            const localVarPath = `/api/v{version}/alerts`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {UpdateAlertCommand} updateAlertCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsUpdateAlert(version: string, updateAlertCommand: UpdateAlertCommand, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling alertsUpdateAlert.');
            }
            // verify required parameter 'updateAlertCommand' is not null or undefined
            if (updateAlertCommand === null || updateAlertCommand === undefined) {
                throw new RequiredError('updateAlertCommand','Required parameter updateAlertCommand was null or undefined when calling alertsUpdateAlert.');
            }
            const localVarPath = `/api/v{version}/alerts`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof updateAlertCommand !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateAlertCommand !== undefined ? updateAlertCommand : {}) : (updateAlertCommand || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlertsApi - functional programming interface
 * @export
 */
export const AlertsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddAlertCommand} addAlertCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsAddAlert(version: string, addAlertCommand: AddAlertCommand, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = AlertsApiAxiosParamCreator(configuration).alertsAddAlert(version, addAlertCommand, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsDeleteAlert(id: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = AlertsApiAxiosParamCreator(configuration).alertsDeleteAlert(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsGetAlert(id: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = AlertsApiAxiosParamCreator(configuration).alertsGetAlert(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsGetAlerts(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = AlertsApiAxiosParamCreator(configuration).alertsGetAlerts(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {UpdateAlertCommand} updateAlertCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsUpdateAlert(version: string, updateAlertCommand: UpdateAlertCommand, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = AlertsApiAxiosParamCreator(configuration).alertsUpdateAlert(version, updateAlertCommand, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AlertsApi - factory interface
 * @export
 */
export const AlertsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddAlertCommand} addAlertCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsAddAlert(version: string, addAlertCommand: AddAlertCommand, options?: any): AxiosPromise<any> {
            return AlertsApiFp(configuration).alertsAddAlert(version, addAlertCommand, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsDeleteAlert(id: string, version: string, options?: any): AxiosPromise<any> {
            return AlertsApiFp(configuration).alertsDeleteAlert(id, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsGetAlert(id: string, version: string, options?: any): AxiosPromise<any> {
            return AlertsApiFp(configuration).alertsGetAlert(id, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsGetAlerts(version: string, options?: any): AxiosPromise<any> {
            return AlertsApiFp(configuration).alertsGetAlerts(version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {UpdateAlertCommand} updateAlertCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertsUpdateAlert(version: string, updateAlertCommand: UpdateAlertCommand, options?: any): AxiosPromise<any> {
            return AlertsApiFp(configuration).alertsUpdateAlert(version, updateAlertCommand, options)(axios, basePath);
        },
    };
};

/**
 * AlertsApi - object-oriented interface
 * @export
 * @class AlertsApi
 * @extends {BaseAPI}
 */
export class AlertsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {AddAlertCommand} addAlertCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    public alertsAddAlert(version: string, addAlertCommand: AddAlertCommand, options?: any) {
        return AlertsApiFp(this.configuration).alertsAddAlert(version, addAlertCommand, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    public alertsDeleteAlert(id: string, version: string, options?: any) {
        return AlertsApiFp(this.configuration).alertsDeleteAlert(id, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    public alertsGetAlert(id: string, version: string, options?: any) {
        return AlertsApiFp(this.configuration).alertsGetAlert(id, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    public alertsGetAlerts(version: string, options?: any) {
        return AlertsApiFp(this.configuration).alertsGetAlerts(version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {UpdateAlertCommand} updateAlertCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    public alertsUpdateAlert(version: string, updateAlertCommand: UpdateAlertCommand, options?: any) {
        return AlertsApiFp(this.configuration).alertsUpdateAlert(version, updateAlertCommand, options)(this.axios, this.basePath);
    }

}


/**
 * ApplicationStatusApi - axios parameter creator
 * @export
 */
export const ApplicationStatusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} sceneID 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationStatusBySceneID(sceneID: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'sceneID' is not null or undefined
            if (sceneID === null || sceneID === undefined) {
                throw new RequiredError('sceneID','Required parameter sceneID was null or undefined when calling getApplicationStatusBySceneID.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getApplicationStatusBySceneID.');
            }
            const localVarPath = `/api/v{version}/bostools/applicationstatus/{sceneID}`
                .replace(`{${"sceneID"}}`, encodeURIComponent(String(sceneID)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sceneID 
         * @param {string} version 
         * @param {number} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicationStatus(sceneID: string, version: string, status?: number, options: any = {}): RequestArgs {
            // verify required parameter 'sceneID' is not null or undefined
            if (sceneID === null || sceneID === undefined) {
                throw new RequiredError('sceneID','Required parameter sceneID was null or undefined when calling updateApplicationStatus.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling updateApplicationStatus.');
            }
            const localVarPath = `/api/v{version}/bostools/applicationstatus/{sceneID}`
                .replace(`{${"sceneID"}}`, encodeURIComponent(String(sceneID)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicationStatusApi - functional programming interface
 * @export
 */
export const ApplicationStatusApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} sceneID 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationStatusBySceneID(sceneID: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationStatusDto> {
            const localVarAxiosArgs = ApplicationStatusApiAxiosParamCreator(configuration).getApplicationStatusBySceneID(sceneID, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} sceneID 
         * @param {string} version 
         * @param {number} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicationStatus(sceneID: string, version: string, status?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = ApplicationStatusApiAxiosParamCreator(configuration).updateApplicationStatus(sceneID, version, status, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ApplicationStatusApi - factory interface
 * @export
 */
export const ApplicationStatusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} sceneID 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationStatusBySceneID(sceneID: string, version: string, options?: any): AxiosPromise<ApplicationStatusDto> {
            return ApplicationStatusApiFp(configuration).getApplicationStatusBySceneID(sceneID, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} sceneID 
         * @param {string} version 
         * @param {number} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicationStatus(sceneID: string, version: string, status?: number, options?: any): AxiosPromise<number> {
            return ApplicationStatusApiFp(configuration).updateApplicationStatus(sceneID, version, status, options)(axios, basePath);
        },
    };
};

/**
 * ApplicationStatusApi - object-oriented interface
 * @export
 * @class ApplicationStatusApi
 * @extends {BaseAPI}
 */
export class ApplicationStatusApi extends BaseAPI {
    /**
     * 
     * @param {string} sceneID 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationStatusApi
     */
    public getApplicationStatusBySceneID(sceneID: string, version: string, options?: any) {
        return ApplicationStatusApiFp(this.configuration).getApplicationStatusBySceneID(sceneID, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} sceneID 
     * @param {string} version 
     * @param {number} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationStatusApi
     */
    public updateApplicationStatus(sceneID: string, version: string, status?: number, options?: any) {
        return ApplicationStatusApiFp(this.configuration).updateApplicationStatus(sceneID, version, status, options)(this.axios, this.basePath);
    }

}


/**
 * CaseAgentNumberApi - axios parameter creator
 * @export
 */
export const CaseAgentNumberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [caseNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseAgentNumbersByCaseNumber(version: string, caseNumber?: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getCaseAgentNumbersByCaseNumber.');
            }
            const localVarPath = `/api/v{version}/bostools/caseagentnumber`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (caseNumber !== undefined) {
                localVarQueryParameter['caseNumber'] = caseNumber;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} caseID 
         * @param {string} version 
         * @param {CaseAgentNumber} caseAgentNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseAgentNumber(caseID: string, version: string, caseAgentNumber: CaseAgentNumber, options: any = {}): RequestArgs {
            // verify required parameter 'caseID' is not null or undefined
            if (caseID === null || caseID === undefined) {
                throw new RequiredError('caseID','Required parameter caseID was null or undefined when calling updateCaseAgentNumber.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling updateCaseAgentNumber.');
            }
            // verify required parameter 'caseAgentNumber' is not null or undefined
            if (caseAgentNumber === null || caseAgentNumber === undefined) {
                throw new RequiredError('caseAgentNumber','Required parameter caseAgentNumber was null or undefined when calling updateCaseAgentNumber.');
            }
            const localVarPath = `/api/v{version}/bostools/caseagentnumber/{caseID}`
                .replace(`{${"caseID"}}`, encodeURIComponent(String(caseID)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof caseAgentNumber !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(caseAgentNumber !== undefined ? caseAgentNumber : {}) : (caseAgentNumber || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseAgentNumberApi - functional programming interface
 * @export
 */
export const CaseAgentNumberApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [caseNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseAgentNumbersByCaseNumber(version: string, caseNumber?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CaseAgentNumberDto>> {
            const localVarAxiosArgs = CaseAgentNumberApiAxiosParamCreator(configuration).getCaseAgentNumbersByCaseNumber(version, caseNumber, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} caseID 
         * @param {string} version 
         * @param {CaseAgentNumber} caseAgentNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseAgentNumber(caseID: string, version: string, caseAgentNumber: CaseAgentNumber, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = CaseAgentNumberApiAxiosParamCreator(configuration).updateCaseAgentNumber(caseID, version, caseAgentNumber, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CaseAgentNumberApi - factory interface
 * @export
 */
export const CaseAgentNumberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [caseNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseAgentNumbersByCaseNumber(version: string, caseNumber?: string, options?: any): AxiosPromise<Array<CaseAgentNumberDto>> {
            return CaseAgentNumberApiFp(configuration).getCaseAgentNumbersByCaseNumber(version, caseNumber, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} caseID 
         * @param {string} version 
         * @param {CaseAgentNumber} caseAgentNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseAgentNumber(caseID: string, version: string, caseAgentNumber: CaseAgentNumber, options?: any): AxiosPromise<number> {
            return CaseAgentNumberApiFp(configuration).updateCaseAgentNumber(caseID, version, caseAgentNumber, options)(axios, basePath);
        },
    };
};

/**
 * CaseAgentNumberApi - object-oriented interface
 * @export
 * @class CaseAgentNumberApi
 * @extends {BaseAPI}
 */
export class CaseAgentNumberApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {string} [caseNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseAgentNumberApi
     */
    public getCaseAgentNumbersByCaseNumber(version: string, caseNumber?: string, options?: any) {
        return CaseAgentNumberApiFp(this.configuration).getCaseAgentNumbersByCaseNumber(version, caseNumber, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} caseID 
     * @param {string} version 
     * @param {CaseAgentNumber} caseAgentNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseAgentNumberApi
     */
    public updateCaseAgentNumber(caseID: string, version: string, caseAgentNumber: CaseAgentNumber, options?: any) {
        return CaseAgentNumberApiFp(this.configuration).updateCaseAgentNumber(caseID, version, caseAgentNumber, options)(this.axios, this.basePath);
    }

}


/**
 * CaseNameApi - axios parameter creator
 * @export
 */
export const CaseNameApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [caseNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseNamesByCaseNumber(version: string, caseNumber?: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getCaseNamesByCaseNumber.');
            }
            const localVarPath = `/api/v{version}/bostools/casenames`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (caseNumber !== undefined) {
                localVarQueryParameter['caseNumber'] = caseNumber;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupID 
         * @param {string} version 
         * @param {string} [caseName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseName(groupID: string, version: string, caseName?: string, options: any = {}): RequestArgs {
            // verify required parameter 'groupID' is not null or undefined
            if (groupID === null || groupID === undefined) {
                throw new RequiredError('groupID','Required parameter groupID was null or undefined when calling updateCaseName.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling updateCaseName.');
            }
            const localVarPath = `/api/v{version}/bostools/casenames/{groupID}`
                .replace(`{${"groupID"}}`, encodeURIComponent(String(groupID)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (caseName !== undefined) {
                localVarQueryParameter['caseName'] = caseName;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseNameApi - functional programming interface
 * @export
 */
export const CaseNameApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [caseNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseNamesByCaseNumber(version: string, caseNumber?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CaseNameDto>> {
            const localVarAxiosArgs = CaseNameApiAxiosParamCreator(configuration).getCaseNamesByCaseNumber(version, caseNumber, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} groupID 
         * @param {string} version 
         * @param {string} [caseName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseName(groupID: string, version: string, caseName?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = CaseNameApiAxiosParamCreator(configuration).updateCaseName(groupID, version, caseName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CaseNameApi - factory interface
 * @export
 */
export const CaseNameApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [caseNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseNamesByCaseNumber(version: string, caseNumber?: string, options?: any): AxiosPromise<Array<CaseNameDto>> {
            return CaseNameApiFp(configuration).getCaseNamesByCaseNumber(version, caseNumber, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} groupID 
         * @param {string} version 
         * @param {string} [caseName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseName(groupID: string, version: string, caseName?: string, options?: any): AxiosPromise<number> {
            return CaseNameApiFp(configuration).updateCaseName(groupID, version, caseName, options)(axios, basePath);
        },
    };
};

/**
 * CaseNameApi - object-oriented interface
 * @export
 * @class CaseNameApi
 * @extends {BaseAPI}
 */
export class CaseNameApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {string} [caseNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNameApi
     */
    public getCaseNamesByCaseNumber(version: string, caseNumber?: string, options?: any) {
        return CaseNameApiFp(this.configuration).getCaseNamesByCaseNumber(version, caseNumber, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} groupID 
     * @param {string} version 
     * @param {string} [caseName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNameApi
     */
    public updateCaseName(groupID: string, version: string, caseName?: string, options?: any) {
        return CaseNameApiFp(this.configuration).updateCaseName(groupID, version, caseName, options)(this.axios, this.basePath);
    }

}


/**
 * GrandfatheringDataApi - axios parameter creator
 * @export
 */
export const GrandfatheringDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrandfatheringData(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getGrandfatheringData.');
            }
            const localVarPath = `/api/v{version}/bostools/grandfatheringdata`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GrandfatheringDataApi - functional programming interface
 * @export
 */
export const GrandfatheringDataApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrandfatheringData(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfGrandfatheringDataDto> {
            const localVarAxiosArgs = GrandfatheringDataApiAxiosParamCreator(configuration).getGrandfatheringData(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * GrandfatheringDataApi - factory interface
 * @export
 */
export const GrandfatheringDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrandfatheringData(version: string, options?: any): AxiosPromise<PagedResultOfGrandfatheringDataDto> {
            return GrandfatheringDataApiFp(configuration).getGrandfatheringData(version, options)(axios, basePath);
        },
    };
};

/**
 * GrandfatheringDataApi - object-oriented interface
 * @export
 * @class GrandfatheringDataApi
 * @extends {BaseAPI}
 */
export class GrandfatheringDataApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrandfatheringDataApi
     */
    public getGrandfatheringData(version: string, options?: any) {
        return GrandfatheringDataApiFp(this.configuration).getGrandfatheringData(version, options)(this.axios, this.basePath);
    }

}


/**
 * LifeApi - axios parameter creator
 * @export
 */
export const LifeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [accountNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeDetailsByAccountNumber(version: string, accountNumber?: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getLifeDetailsByAccountNumber.');
            }
            const localVarPath = `/api/v{version}/bostools/life`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (accountNumber !== undefined) {
                localVarQueryParameter['accountNumber'] = accountNumber;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employerID 
         * @param {string} version 
         * @param {boolean} [writtenToL70] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWrittenToL70Flag(employerID: number, version: string, writtenToL70?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'employerID' is not null or undefined
            if (employerID === null || employerID === undefined) {
                throw new RequiredError('employerID','Required parameter employerID was null or undefined when calling updateWrittenToL70Flag.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling updateWrittenToL70Flag.');
            }
            const localVarPath = `/api/v{version}/bostools/life/{employerID}`
                .replace(`{${"employerID"}}`, encodeURIComponent(String(employerID)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (writtenToL70 !== undefined) {
                localVarQueryParameter['writtenToL70'] = writtenToL70;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LifeApi - functional programming interface
 * @export
 */
export const LifeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [accountNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeDetailsByAccountNumber(version: string, accountNumber?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LifeDetailDto>> {
            const localVarAxiosArgs = LifeApiAxiosParamCreator(configuration).getLifeDetailsByAccountNumber(version, accountNumber, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} employerID 
         * @param {string} version 
         * @param {boolean} [writtenToL70] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWrittenToL70Flag(employerID: number, version: string, writtenToL70?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = LifeApiAxiosParamCreator(configuration).updateWrittenToL70Flag(employerID, version, writtenToL70, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LifeApi - factory interface
 * @export
 */
export const LifeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [accountNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeDetailsByAccountNumber(version: string, accountNumber?: string, options?: any): AxiosPromise<Array<LifeDetailDto>> {
            return LifeApiFp(configuration).getLifeDetailsByAccountNumber(version, accountNumber, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} employerID 
         * @param {string} version 
         * @param {boolean} [writtenToL70] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWrittenToL70Flag(employerID: number, version: string, writtenToL70?: boolean, options?: any): AxiosPromise<number> {
            return LifeApiFp(configuration).updateWrittenToL70Flag(employerID, version, writtenToL70, options)(axios, basePath);
        },
    };
};

/**
 * LifeApi - object-oriented interface
 * @export
 * @class LifeApi
 * @extends {BaseAPI}
 */
export class LifeApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {string} [accountNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LifeApi
     */
    public getLifeDetailsByAccountNumber(version: string, accountNumber?: string, options?: any) {
        return LifeApiFp(this.configuration).getLifeDetailsByAccountNumber(version, accountNumber, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} employerID 
     * @param {string} version 
     * @param {boolean} [writtenToL70] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LifeApi
     */
    public updateWrittenToL70Flag(employerID: number, version: string, writtenToL70?: boolean, options?: any) {
        return LifeApiFp(this.configuration).updateWrittenToL70Flag(employerID, version, writtenToL70, options)(this.axios, this.basePath);
    }

}


/**
 * SicCodeApi - axios parameter creator
 * @export
 */
export const SicCodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [caseNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSicCodesByCaseNumber(version: string, caseNumber?: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getSicCodesByCaseNumber.');
            }
            const localVarPath = `/api/v{version}/bostools/siccode`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (caseNumber !== undefined) {
                localVarQueryParameter['caseNumber'] = caseNumber;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupID 
         * @param {string} version 
         * @param {string} [sicCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSicCode(groupID: string, version: string, sicCode?: string, options: any = {}): RequestArgs {
            // verify required parameter 'groupID' is not null or undefined
            if (groupID === null || groupID === undefined) {
                throw new RequiredError('groupID','Required parameter groupID was null or undefined when calling updateSicCode.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling updateSicCode.');
            }
            const localVarPath = `/api/v{version}/bostools/siccode/{groupID}`
                .replace(`{${"groupID"}}`, encodeURIComponent(String(groupID)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (sicCode !== undefined) {
                localVarQueryParameter['sicCode'] = sicCode;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SicCodeApi - functional programming interface
 * @export
 */
export const SicCodeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [caseNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSicCodesByCaseNumber(version: string, caseNumber?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SicCodeDto>> {
            const localVarAxiosArgs = SicCodeApiAxiosParamCreator(configuration).getSicCodesByCaseNumber(version, caseNumber, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} groupID 
         * @param {string} version 
         * @param {string} [sicCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSicCode(groupID: string, version: string, sicCode?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = SicCodeApiAxiosParamCreator(configuration).updateSicCode(groupID, version, sicCode, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SicCodeApi - factory interface
 * @export
 */
export const SicCodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [caseNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSicCodesByCaseNumber(version: string, caseNumber?: string, options?: any): AxiosPromise<Array<SicCodeDto>> {
            return SicCodeApiFp(configuration).getSicCodesByCaseNumber(version, caseNumber, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} groupID 
         * @param {string} version 
         * @param {string} [sicCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSicCode(groupID: string, version: string, sicCode?: string, options?: any): AxiosPromise<number> {
            return SicCodeApiFp(configuration).updateSicCode(groupID, version, sicCode, options)(axios, basePath);
        },
    };
};

/**
 * SicCodeApi - object-oriented interface
 * @export
 * @class SicCodeApi
 * @extends {BaseAPI}
 */
export class SicCodeApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {string} [caseNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SicCodeApi
     */
    public getSicCodesByCaseNumber(version: string, caseNumber?: string, options?: any) {
        return SicCodeApiFp(this.configuration).getSicCodesByCaseNumber(version, caseNumber, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} groupID 
     * @param {string} version 
     * @param {string} [sicCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SicCodeApi
     */
    public updateSicCode(groupID: string, version: string, sicCode?: string, options?: any) {
        return SicCodeApiFp(this.configuration).updateSicCode(groupID, version, sicCode, options)(this.axios, this.basePath);
    }

}


